if($('#services-search').length) {

    let searchContainer = $('#services-search'),
        featuredServices = $('.featured-services-container'),
        searchForm = $('#services-search-form'),
        searchInput = $('#services-search-input'),
        resultsContainer = $('#service-search-results'),
        paginationContainer = $('#services-pagination-container'),
        paginationDisplay = $('.services-pagination-display'),
        previousSearch = '',
        initialSearchComplete = false,
        letterFilter = '',
        letterClearButton = $('.service-clear-letter'),
        letterFilterButtons = $('.services-filter-letter button'),
        cityFilterItems = $('.service-filter-city'),
        currentFilterTags = $('.services-current-filter-tags'),
        page = 1;

    searchInput.on('keyup update', function() {
        if(searchInput.val().length > 0) {
            featuredServices.slideUp();
        } else {
            featuredServices.slideDown();
        }

        if(previousSearch.length > 0 && searchInput.val().length === 0) {
            servicesSearch();
        }

        previousSearch = searchInput.val();
    });

    searchInput.on('keyup update', debounce(function () {

        if(searchInput.val().length > 2) {
            servicesSearch();
        }

    }, 500));

    function debounce (fn, delay) {
        var timeoutID = null
        return function () {
            clearTimeout(timeoutID)
            var args = arguments
            var that = this
            timeoutID = setTimeout(function () {
                fn.apply(that, args)
            }, delay)
        }
    }

    searchForm.on('submit', function(e) {
        e.preventDefault();

        servicesSearch();
    });

    $(document).on('click', '.services-page-link', function (e) {
        e.preventDefault();
        page = $(this).data('page');
        servicesSearch();
    });

    $(document).on('click', '.services-page-prev', function (e) {
        e.preventDefault();
        if($(this).hasClass('disabled')) return;
        page--;
        servicesSearch();
    });

    $(document).on('click', '.services-page-next', function (e) {
        e.preventDefault();
        if($(this).hasClass('disabled')) return;
        page++;
        servicesSearch();
    });

    letterFilterButtons.on('click', function() {
        if($(this).hasClass('service-clear-letter')) return;

        if($(this).hasClass('is-checked')) {
            $(this).removeClass('is-checked');
            letterFilter = '';
            servicesSearch();
            return;
        }

        letterFilterButtons.removeClass('is-checked');
        $(this).addClass('is-checked');
        letterClearButton.addClass('active');
        letterFilter = $(this).data('letter');

        $('.js-services-clear').removeClass('d-none');
        servicesSearch();
    });

    letterClearButton.on('click', function() {
        letterFilterButtons.removeClass('is-checked');
        $(this).removeClass('active');
        letterFilter = '';
        $('.press-release-clear').addClass('d-none');
        servicesSearch();
    });

    cityFilterItems.on('click', function(e) {
        e.preventDefault();
        $(this).parent().toggleClass('is-checked');
        if ($('.is-checked').length > 0) {
            $('.js-services-clear').removeClass('d-none');
        } else {
            $('.js-services-clear').addClass('d-none');
        }
        servicesSearch();
    });

    $(document).on('click', '.services-current-filter-tags button', function () {
        $('.service-filter-city-' + $(this).data('city')).parent().removeClass('is-checked');
        if ($('.is-checked').length > 0) {
            $('.js-services-clear').removeClass('d-none');
        } else {
            $('.js-services-clear').addClass('d-none');
        }
        servicesSearch();
    });

    $(document).on('click', '.view-all-cities', function (e) {
        e.preventDefault();

        $('.city-hidden').toggleClass('d-none');

        if ($('.city-hidden').hasClass('d-none')) {
            $(this).text('View All');
        } else {
            $(this).text('View Less');
        }
    });


    $(document).on('click', '.js-services-clear', function () {
        $('.press-release-filter-category').each(function() {
            $('.press-release-filter-category-' + $(this).data('category')).parent().removeClass('is-checked');
        });

        letterFilterButtons.removeClass('is-checked');
        letterClearButton.removeClass('active');
        letterFilter = '';

        cityFilterItems.parent().removeClass('is-checked');

        $('.js-services-clear').addClass('d-none');

        page = 1;

        servicesSearch();
    });



    function servicesSearch() {

        let cityFilters = [];

        cityFilterItems.each(function() {
            if($(this).parent().hasClass('is-checked')) {
                cityFilters.push($(this).data('city'));
            }
        });

        $.post("/wp-admin/admin-ajax.php", {
            'action': 'services_search',
            'query': searchInput.val(),
            'letter': letterFilter,
            'cities': cityFilters,
            'page': page,
        }, function (response) {

            resultsContainer.html(response.data.results);
            paginationContainer.html(response.data.pagination);
            paginationDisplay.html(response.data.pagination_display);
            currentFilterTags.html(response.data.current_filter_tags);

            if(searchInput.val().length > 0) {
                $('html, body').animate({
                    scrollTop: searchContainer.offset().top
                }, 500);
            } else {
                $('html, body').animate({
                    scrollTop: $('#service-search').offset().top
                }, 500);
            }

        });

    }

}
